import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

type NotificationsCounterProps = ComponentPropsWithoutRef<'span'>;

const NotificationsCounter = ({ children, className }: NotificationsCounterProps) => {
    return (
        <span
            data-testid="notifications-counter"
            className={clsx(
                'h-3.5 min-w-m rounded-full border border-white bg-icoRed px-0.5 text-7 text-white dark:border-icoDarkMode-anthracite',
                className
            )}>
            {children}
        </span>
    );
};

export default NotificationsCounter;
